import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import React from "react";
import {Button} from "@mui/material";
import {Trans} from "../../utils/i18n";

export default function HiddenStatus({item, setStatusHidden,}) {
    let status = 'waiting';

    if (item.datetime && item.exception) {
        status = 'failed';
    } else if (item.datetime) {
        status = 'success';
    }

    return (
        <div className={'w-full flex flex-col items-center justify-center gap-6 mt-6'}>
            <Button variant={'outlined'} color={'primary'} onClick={() => setStatusHidden(false)}>
                <Trans i18nKey={"showHiddenStatus"}>
                    Show hidden Status
                </Trans>
            </Button>
            <ArrowDownwardIcon/>
        </div>
    );
}
